export default __webpack_public_path__ + "static/media/Stalker's Boots of the Hidden Tomb.692baf84.jpg";